// extracted by mini-css-extract-plugin
export default {"input":"styles_input__GxVyP","inputLabel":"styles_inputLabel__qs1KC","inputLabelText":"styles_inputLabelText__hidFn","inputField":"styles_inputField__PF1yO"};